<template lang="">
  <div
    class="card-flash-offer d-flex flex-column justify-content-between justify-content-lg-between p-2 p-lg-3 border bg-dark"
  >
    <h4 class="text-white text-center of-discount m-0 p-0">
      0% {{ product.discount_final_percentage }} {{ $t("of discount") }}
    </h4>
    <div class="d-flex justify-content-center align-items-center">
      <image-product
        :image="firstImage"
        :max-height="120"
        :max-sm-height="80"
        class="p-0 m-0"
      />
    </div>
    <span class="text-white text-center finish_at mt-2 mb-1">
      {{ $t("Ends at") }}:
    </span>
    <div class="w-75 w-lg-50 mx-auto d-flex justify-content-around">
      <div
        class="d-flex justify-content-center align-items-center p-1 bg-gray-700 clock"
      >
        <div class="text-white text-center d-flex flex-column">
          <span class="hours"> {{ hours }} </span>
          <span class="title-time mt-0 mt-lg-1"> {{ $t("hrs") }} </span>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center p-1 bg-gray-700 clock"
      >
        <div class="text-white text-center d-flex flex-column">
          <span class="minutes"> {{ minutes }} </span>
          <span class="title-time mt-0 mt-lg-1"> {{ $t("min") }} </span>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center p-1 bg-gray-700 clock"
      >
        <div class="text-white text-center d-flex flex-column">
          <span class="seconds"> {{ seconds }} </span>
          <span class="title-time mt-0 mt-lg-1"> {{ $t("sec") }} </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import ImageProduct from "~/components/ui/ImageProduct.vue";
export default {
  components: {
    ImageProduct,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      seconds: 0,
      minutes: 0,
      hours: 0,
      intervalId: null as any | null,
    };
  },
  computed: {
    firstImage() {
      if (
        this.product &&
        this.product.images &&
        this.product.images.length > 0
      ) {
        return this.product.images[0].image;
      }
      return "/images/imagen-no-disponible.png";
    },
  },
  created() {
    if (this.product && this.product.promotion_end_date) {
      const expirationDate: any = new Date(this.product.promotion_end_date);
      const now: any = new Date();
      const diffMilliseconds = expirationDate - now;

      if (diffMilliseconds > 0) {
        const seconds = Math.floor(diffMilliseconds / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);

        const secondsRemaining = seconds % 60;
        const minutesRemaining = minutes % 60;

        this.hours = hours;
        this.minutes = minutesRemaining;
        this.seconds = secondsRemaining;

        this.intervalId = setInterval(() => {
          this.seconds--;
          if (this.seconds == -1) {
            this.seconds = 59;
            this.minutes--;
          }
          if (this.minutes == -1) {
            this.minutes = 59;
            this.hours--;
          }
        }, 1000);
      } else {
        this.destroyInterval();
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
      }
    }
  },
  unmounted() {
    this.destroyInterval();
  },
  methods: {
    destroyInterval() {
      if (this.intervalId !== null) {
        clearTimeout(this.intervalId);
        this.intervalId = null;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.card-flash-offer
    height: 136px
    @media (min-width: 768px)
        height: 270px

    @media (min-width: 1400px)
        height: 288px

.card-flash-offer img
    width: auto
    object-fit: contain
    max-height: 50px
    @media (min-width: 992px)
        max-height: 120px

.clock
    width: 28px
    height: 28px
    @media (min-width: 992px)
        width: 48px
        height: 48px
</style>
